/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import { ProjectListItemFragmentDoc } from '../projects/components/ProjectListItem.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EditTodoItemModalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EditTodoItemModalQuery = { todoItem?: { __typename: 'TodoItem', id: string, title: string, description: string, time?: any | null, isDone: boolean, completedAt?: any | null, createdAt: any, assignee?: { __typename: 'User', id: string } | null, attachments: Array<{ __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }>, completedBy?: { __typename: 'User', id: string, fullname: string } | null, createdBy: { __typename: 'User', id: string, fullname: string }, linkedCrmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, linkedCrmUser?: { __typename: 'CrmPerson', id: string, fullname: string, firstname: string, familyname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, linkedProject?: { __typename: 'Project', id: string, viewerPermissions: Array<Types.PermissionName>, title: string, deadline?: any | null, overdue: boolean, state: Types.ProjectStateMachineStatus, number: string, createdAt?: any | null, categories: Array<string>, type?: Types.ProjectType | null, leadId?: number | null, urgent: boolean, earliestStart?: any | null, earliestPlanSessionDate?: any | null, planned: boolean, phase: { __typename: 'OrganisationProjectPhase', id: string, name: string, applicableForState: Types.ProjectStateMachineStatus, color: string }, budget?: { __typename: 'Money', currency: string, amount: number } | null, plannedUsers: Array<{ __typename: 'User', id: string, firstname: string, familyname: string } | null>, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } | null, buildingInfo?: { __typename: 'BuildingInfo', id: string, buildingAddress?: { __typename: 'Address', streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, contactPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null } | null, crmLinks: Array<{ __typename: 'ProjectLinkCrmOrganisation', id: string, linkAs: string, crmOrganisation: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } | { __typename: 'ProjectLinkCrmUser', id: string, linkAs: string, crmUser: { __typename: 'CrmPerson', id: string, fullname: string, firstname: string, familyname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, crmCompany: { __typename: 'CrmCompany', id: string } } }>, source: { __typename: 'ProjectSource', id: string, source: Types.ProjectSourceType, importFileName?: string | null, manualPageName?: Types.ProjectSourcePageName | null, quoteProductsDistributionId?: string | null, requestId?: string | null, requestTitle?: string | null, flowTemplateId?: string | null, flowTemplateTitle?: string | null, flowTemplateVersionCounter?: number | null, flowCallId?: string | null } } | null, team?: { __typename: 'Team', id: string, name: string, isActive: boolean } | null } | null };

export type SetTodoTeamMutationVariables = Types.Exact<{
  input: Types.SetTodoTeamInput;
}>;


export type SetTodoTeamMutation = { setTodoTeam: { __typename: 'SetTodoTeamResult', todoItem: { __typename: 'TodoItem', id: string, team?: { __typename: 'Team', id: string, name: string, isActive: boolean } | null } } };

export type ModifyTodoItemMutationVariables = Types.Exact<{
  input: Types.ModifyTodoItemInput;
}>;


export type ModifyTodoItemMutation = { modifyTodoItem: { __typename: 'ModifyTodoItemResult', todoItem: { __typename: 'TodoItem', id: string, title: string, description: string, time?: any | null, isDone: boolean, completedAt?: any | null, assignee?: { __typename: 'User', id: string } | null, attachments: Array<{ __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }>, completedBy?: { __typename: 'User', id: string, fullname: string } | null, linkedCrmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, linkedCrmUser?: { __typename: 'CrmPerson', id: string, fullname: string, firstname: string, familyname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, linkedProject?: { __typename: 'Project', id: string, viewerPermissions: Array<Types.PermissionName>, title: string, deadline?: any | null, overdue: boolean, state: Types.ProjectStateMachineStatus, number: string, createdAt?: any | null, categories: Array<string>, type?: Types.ProjectType | null, leadId?: number | null, urgent: boolean, earliestStart?: any | null, earliestPlanSessionDate?: any | null, planned: boolean, phase: { __typename: 'OrganisationProjectPhase', id: string, name: string, applicableForState: Types.ProjectStateMachineStatus, color: string }, budget?: { __typename: 'Money', currency: string, amount: number } | null, plannedUsers: Array<{ __typename: 'User', id: string, firstname: string, familyname: string } | null>, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } | null, buildingInfo?: { __typename: 'BuildingInfo', id: string, buildingAddress?: { __typename: 'Address', streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, contactPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null } | null, crmLinks: Array<{ __typename: 'ProjectLinkCrmOrganisation', id: string, linkAs: string, crmOrganisation: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } | { __typename: 'ProjectLinkCrmUser', id: string, linkAs: string, crmUser: { __typename: 'CrmPerson', id: string, fullname: string, firstname: string, familyname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, crmCompany: { __typename: 'CrmCompany', id: string } } }>, source: { __typename: 'ProjectSource', id: string, source: Types.ProjectSourceType, importFileName?: string | null, manualPageName?: Types.ProjectSourcePageName | null, quoteProductsDistributionId?: string | null, requestId?: string | null, requestTitle?: string | null, flowTemplateId?: string | null, flowTemplateTitle?: string | null, flowTemplateVersionCounter?: number | null, flowCallId?: string | null } } | null } } };


export const EditTodoItemModalDocument = gql`
    query EditTodoItemModal($id: ID!) {
  todoItem(id: $id) {
    id
    title
    description
    time
    assignee {
      id
    }
    attachments {
      ...AttachmentSnapshot
    }
    isDone
    completedAt
    completedBy {
      id
      fullname
    }
    createdAt
    createdBy {
      id
      fullname
    }
    linkedCrmOrganisation {
      id
      title
      logo {
        ...AttachmentSnapshot
      }
    }
    linkedCrmUser {
      id
      fullname
      firstname
      familyname
      avatar {
        ...AttachmentSnapshot
      }
    }
    linkedProject {
      id
      ...ProjectListItem
    }
    team {
      id
      name
      isActive
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}
${ProjectListItemFragmentDoc}`;

/**
 * __useEditTodoItemModalQuery__
 *
 * To run a query within a React component, call `useEditTodoItemModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditTodoItemModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditTodoItemModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditTodoItemModalQuery(baseOptions: Apollo.QueryHookOptions<EditTodoItemModalQuery, EditTodoItemModalQueryVariables> & ({ variables: EditTodoItemModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditTodoItemModalQuery, EditTodoItemModalQueryVariables>(EditTodoItemModalDocument, options);
      }
export function useEditTodoItemModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditTodoItemModalQuery, EditTodoItemModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditTodoItemModalQuery, EditTodoItemModalQueryVariables>(EditTodoItemModalDocument, options);
        }
export function useEditTodoItemModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditTodoItemModalQuery, EditTodoItemModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditTodoItemModalQuery, EditTodoItemModalQueryVariables>(EditTodoItemModalDocument, options);
        }
export type EditTodoItemModalQueryHookResult = ReturnType<typeof useEditTodoItemModalQuery>;
export type EditTodoItemModalLazyQueryHookResult = ReturnType<typeof useEditTodoItemModalLazyQuery>;
export type EditTodoItemModalSuspenseQueryHookResult = ReturnType<typeof useEditTodoItemModalSuspenseQuery>;
export type EditTodoItemModalQueryResult = Apollo.QueryResult<EditTodoItemModalQuery, EditTodoItemModalQueryVariables>;
export const SetTodoTeamDocument = gql`
    mutation SetTodoTeam($input: SetTodoTeamInput!) {
  setTodoTeam(input: $input) {
    ... on SetTodoTeamResult {
      todoItem {
        id
        team {
          id
          name
          isActive
        }
      }
    }
  }
}
    `;
export type SetTodoTeamMutationFn = Apollo.MutationFunction<SetTodoTeamMutation, SetTodoTeamMutationVariables>;

/**
 * __useSetTodoTeamMutation__
 *
 * To run a mutation, you first call `useSetTodoTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTodoTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTodoTeamMutation, { data, loading, error }] = useSetTodoTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTodoTeamMutation(baseOptions?: Apollo.MutationHookOptions<SetTodoTeamMutation, SetTodoTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTodoTeamMutation, SetTodoTeamMutationVariables>(SetTodoTeamDocument, options);
      }
export type SetTodoTeamMutationHookResult = ReturnType<typeof useSetTodoTeamMutation>;
export type SetTodoTeamMutationResult = Apollo.MutationResult<SetTodoTeamMutation>;
export type SetTodoTeamMutationOptions = Apollo.BaseMutationOptions<SetTodoTeamMutation, SetTodoTeamMutationVariables>;
export const ModifyTodoItemDocument = gql`
    mutation ModifyTodoItem($input: ModifyTodoItemInput!) {
  modifyTodoItem(input: $input) {
    todoItem {
      id
      title
      description
      time
      assignee {
        id
      }
      attachments {
        ...AttachmentSnapshot
      }
      isDone
      completedAt
      completedBy {
        id
        fullname
      }
      linkedCrmOrganisation {
        id
        id
        logo {
          ...AttachmentSnapshot
        }
        title
      }
      linkedCrmUser {
        id
        id
        avatar {
          ...AttachmentSnapshot
        }
        fullname
        firstname
        familyname
      }
      linkedProject {
        id
        ...ProjectListItem
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}
${ProjectListItemFragmentDoc}`;
export type ModifyTodoItemMutationFn = Apollo.MutationFunction<ModifyTodoItemMutation, ModifyTodoItemMutationVariables>;

/**
 * __useModifyTodoItemMutation__
 *
 * To run a mutation, you first call `useModifyTodoItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyTodoItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyTodoItemMutation, { data, loading, error }] = useModifyTodoItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyTodoItemMutation(baseOptions?: Apollo.MutationHookOptions<ModifyTodoItemMutation, ModifyTodoItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyTodoItemMutation, ModifyTodoItemMutationVariables>(ModifyTodoItemDocument, options);
      }
export type ModifyTodoItemMutationHookResult = ReturnType<typeof useModifyTodoItemMutation>;
export type ModifyTodoItemMutationResult = Apollo.MutationResult<ModifyTodoItemMutation>;
export type ModifyTodoItemMutationOptions = Apollo.BaseMutationOptions<ModifyTodoItemMutation, ModifyTodoItemMutationVariables>;